export default __webpack_public_path__ + "img/2c11a447e1506fd551a480c2e3e57ab4.svg";